import { useAtomValue } from 'jotai';

import { useRecordingControl as useBaseRecordingControl } from '../../session/controls/useRecordingControl';
import { inSessionPatientInformationAtom } from '../state';

export function useRecordingControl() {
  const hasAppointment = !!useAtomValue(inSessionPatientInformationAtom)?.inSessionAppointmentShortId;
  return useBaseRecordingControl(hasAppointment);
}
